import { create } from 'zustand';

export const usePageLoadingtore = create((set) => ({
  loading: false,
  tip: undefined,
  update: ({ loading, tip }) => set({ loading, tip }),
}));
export const usePageLoading = () =>
  usePageLoadingtore((state) => [{ loading: state.loading, tip: state.tip }, state.update]);
